export default function Footer() {
  return (
    <footer className="bg-neutral-950 text-neutral-500">
      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-14">
          <div className="grid grid-cols-1 md:grid-cols-[1.2fr_0.8fr_1fr] gap-12 lg:gap-16">
            <div>
              <a href="#" className="inline-block mb-5">
                <img src="/landing/logo-white.png" alt="와우오더" className="h-7 w-auto" />
              </a>
              <div className="space-y-1.5 text-sm text-neutral-500">
                <p>대표자: <span className="text-neutral-400">박지훈</span></p>
                <p>사업자등록번호: <span className="text-neutral-400">682-03-03697</span></p>
                <p>통신판매업: <span className="text-neutral-400">제 2025-별내-1384호</span></p>
                <p>주소: <span className="text-neutral-400">경기 남양주시 별내중앙로 30 로데오몰 605</span></p>
              </div>
            </div>

            <div className="md:pl-4">
              <h4 className="text-white font-semibold text-sm mb-5">서비스</h4>
              <div className="space-y-2.5 text-sm">
                {['QR 오더', '테이블 관리', '다국어 메뉴', 'POS 연동', '리뷰 연동'].map((t) => (
                  <a key={t} href="#features" className="block text-neutral-400 hover:text-white transition-colors">{t}</a>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-white font-semibold text-sm mb-5">고객지원</h4>
              <div className="space-y-4 text-sm">
                <a
                  href="http://pf.kakao.com/_fgiMX/chat"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block text-neutral-400 hover:text-white transition-colors"
                >
                  카카오톡 채팅 상담하기 →
                </a>
                <div>
                  <p className="text-neutral-500 text-xs mb-1">고객센터</p>
                  <a href="tel:1644-6827" className="text-white text-lg font-bold hover:text-brand-400 transition-colors">1644-6827</a>
                  <p className="text-neutral-500 text-xs mt-0.5">365일 24시간 운영</p>
                </div>
                <div>
                  <p className="text-neutral-500 text-xs mb-1">이메일</p>
                  <a href="mailto:official@woworder.kr" className="text-neutral-400 hover:text-white transition-colors">official@woworder.kr</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-neutral-500">
            <p>&copy; {new Date().getFullYear()} 와우오더. All rights reserved.</p>
            <div className="flex items-center gap-4">
              <a href="/privacy" className="hover:text-white transition-colors">개인정보처리방침</a>
              <span className="text-neutral-700">|</span>
              <a href="/terms" className="hover:text-white transition-colors">서비스이용약관</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
